var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.projectsToDisplay,"label":_vm.label,"multiple":"","chips":"","deletable-chips":""},model:{value:(_vm.localProjects),callback:function ($$v) {_vm.localProjects=$$v},expression:"localProjects"}})}
var staticRenderFns = []

export { render, staticRenderFns }